import { Download } from "lucide-react";
import ReportBug from "@/components/site/ReportBug";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-zinc-200 dark:border-zinc-800 bg-zinc-100 dark:bg-black"
    >
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 bg-yellow-500 text-black grid place-items-center">
                <Download className="w-4 h-4" strokeWidth={3} />
              </div>
              <span className="font-display font-bold text-xl text-zinc-900 dark:text-white tracking-tight">
                GOD <span className="text-yellow-500">of</span> ROAS
              </span>
            </div>
            <p className="mt-6 text-zinc-400 dark:text-zinc-600 dark:text-zinc-400 max-w-md leading-relaxed">
              The fastest way to rip Meta Ad Library videos for research,
              inspiration, and creative teardowns. Built for marketers who move.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <h4 className="text-xs font-mono uppercase tracking-widest text-zinc-500 dark:text-zinc-500 mb-4">
              Product
            </h4>
            <ul className="space-y-3 text-sm">
              {["Features", "How it works", "FAQ", "History"].map((i) => (
                <li key={i}>
                  <a
                    href={`#${i.toLowerCase().replace(/\s+/g, "")}`}
                    className="text-zinc-400 dark:text-zinc-600 dark:text-zinc-400 hover:text-yellow-500 transition-colors"
                  >
                    {i}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <h4 className="text-xs font-mono uppercase tracking-widest text-zinc-500 dark:text-zinc-500 mb-4">
              Legal
            </h4>
            <ul className="space-y-3 text-sm text-zinc-400 dark:text-zinc-600 dark:text-zinc-400">
              <li>Public data · fair use</li>
              <li>Not affiliated with Meta</li>
              <li>Use responsibly</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-zinc-200 dark:border-zinc-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs font-mono uppercase tracking-widest text-zinc-400 dark:text-zinc-600">
            © {new Date().getFullYear()} GOD of ROAS · godofroas.com
          </p>
          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
            <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-3">
              <ReportBug />
              <p
                data-testid="report-bug-tagline"
                className="text-xs font-mono uppercase tracking-widest text-zinc-500"
              >
                Got stuck? <span className="text-zinc-700 dark:text-zinc-300">Help us build it better.</span>
              </p>
            </div>
            <p className="text-xs font-mono uppercase tracking-widest text-zinc-400 dark:text-zinc-600">
              Made with <span className="text-yellow-500">■</span> by marketers,
              for marketers.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
